import { Col, Row, Form, Input, Select, message } from "antd";
import { Dispatch, SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";

type props = {
  customer: any;
  setPhoneNumber: Dispatch<SetStateAction<boolean>>;
  formatedCountryPhone: any
};
function ContactInformation({ customer, setPhoneNumber, formatedCountryPhone }: props) {
  const [t] = useTranslation("common");

  const filterOption = (inputValue: string, option: any) => {
    // Extract the text content from the JSX label
    const label = option?.label?.props?.children;
    if (label) {
      const normalizedInput = inputValue.toLowerCase().trim();
      const normalizedLabel = label.toString().toLowerCase().trim();
      return normalizedLabel.includes(normalizedInput);
    }
    return true;
  };

  const [, setPhoneNumb] = useState("");
  const [, setErrorMessage] = useState("");

  const handlePhoneNumberChange = (e: any) => {
    const value = e.target.value;

    const regex = /^[0-9]*$/;
    if (regex.test(value)) {
      setPhoneNumb(value);
      setErrorMessage("");
    } else {
      setErrorMessage("Please enter numbers only");
    }
  };

  const handlePhoneNumberKeyPress = (e: any) => {
    const keyCode = e.keyCode || e.which;
    const keyValue = String.fromCharCode(keyCode);
    const regex = /[0-9.]|\./;

    if (!regex.test(keyValue)) {
      e.preventDefault();
      message.warning("Please enter numbers only"); // Display warning message
    }

    if (keyValue === "." && e.target.value.indexOf(".") !== -1) {
      e.preventDefault();
      message.warning("Please enter only one decimal point"); // Display warning message
    }
    if (keyValue === "." && e.target.selectionStart === 0) {
      e.preventDefault();
      message.warning("Decimal point cannot be the first character"); // Display warning message
    }
  };

  const selectPhone = (
    <Form.Item noStyle name="areaCodePhone">
      <Select
        showSearch={true}
        filterOption={filterOption}
        style={{ width: 100, background: "white" }}
        options={formatedCountryPhone}
      />
    </Form.Item>
  );

  const selectMobile = (
    <Form.Item noStyle name="areaCodeMobile">
      <Select
        showSearch={true}
        filterOption={filterOption}
        style={{ width: 100, background: "white" }}
        options={formatedCountryPhone}
      />
    </Form.Item>
  );

  const handlePhoneNumber = (event: any) => {
    setPhoneNumber(event);
    handlePhoneNumberChange(event);
  };

  return (
    <>
      <Row>
        <Col md={6}>
          <Form.Item name="email" label={`${t("email")}`}>
            <Input
              maxLength={50}
              autoComplete="off"
              placeholder={`${t("enter-email")}`}
              data-testid="email-input"
            />
          </Form.Item>

          <Form.Item label={`${t("primary-number")}`} name="phone"
            rules={[
              {
                required: true,
                message: `${t('this-field-is-required')}`
              }
            ]}
          >
            <Input
              addonBefore={selectPhone}
              maxLength={20}
              autoComplete="off"
              onChange={handlePhoneNumber}
              onKeyPress={handlePhoneNumberKeyPress}
            />
          </Form.Item>

          <Form.Item
            name="mobile"
            label={`${t("secondary-number")}`}
            initialValue={customer?.phone}
          >
            <Input
              addonBefore={selectMobile}
              maxLength={10}
              autoComplete="off"
              placeholder="000 000 000"
              onChange={handlePhoneNumberChange}
              onKeyPress={handlePhoneNumberKeyPress}
              data-testid="phone-input"
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
}

export default ContactInformation;
